import Dashboard from "views/service/app/Dashboard";
import AllDevices from "views/service/app/AllDevices";
import SingleDeviceTable from "views/service/app/SingleDeviceTable";
import FileManager from "views/service/app/FileManager";
import Todos from "views/service/app/Todos2";






export { Dashboard, AllDevices, SingleDeviceTable, FileManager, Todos};
